<template>
  <aside class="left-sidebar" data-sidebarbg="skin6">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" data-sidebarbg="skin6">
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="sidebar-item">
            <a
              class="sidebar-link sidebar-link"
              href="/dashboard"
              aria-expanded="false"
              ><i data-feather="home" class="feather-icon"></i
              ><span class="hide-menu">Dashboard</span></a
            >
          </li>
          <li class="list-divider"></li>

          <li class="nav-small-cap">
            <span class="hide-menu">Applications</span>
          </li>
          <!-- primer menu item dinamico -->
          <li
            v-for="(item, index) in $options.nav"
            :key="index"
            :class="item.list_class"
          >
            <a :class="item.link_class" :href="item.to" aria-expanded="false"
              ><i :data-feather="item.icon_feather" class="feather-icon"></i
              ><span class="hide-menu">{{ item.name }}</span></a
            >
          </li>
          <!-- Componentes 
          <li class="list-divider"></li>
          <li class="nav-small-cap">
            <span class="hide-menu">Components</span>
          </li>
          <li class="sidebar-item">
            <a
              class="sidebar-link has-arrow"
              href="javascript:void(0)"
              aria-expanded="false"
              ><i data-feather="file-text" class="feather-icon"></i
              ><span class="hide-menu">Forms </span></a
            >
            <ul
              aria-expanded="false"
              class="collapse  first-level base-level-line"
            >
              <li class="sidebar-item">
                <a href="form-inputs.html" class="sidebar-link"
                  ><span class="hide-menu"> Form Inputs </span></a
                >
              </li>
              <li class="sidebar-item">
                <a href="form-input-grid.html" class="sidebar-link"
                  ><span class="hide-menu"> Form Grids </span></a
                >
              </li>
              <li class="sidebar-item">
                <a href="form-checkbox-radio.html" class="sidebar-link"
                  ><span class="hide-menu"> Checkboxes & Radios </span></a
                >
              </li>
            </ul>
          </li>
          -->
        </ul>
      </nav>
      <div style="margin-top: 18rem" class="text-center text-muted">
        © 2020 Vivot Ltd.
      </div>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </aside>
</template>
<script>
import nav from './sidebarItems';
export default {
  name: 'TheSidebar',
  nav,
  components: {},
};

/*

Menu:
        <li class="sidebar-item">
            <a
              class="sidebar-link sidebar-link"
              href="app-chat.html"
              aria-expanded="false"
              ><i data-feather="message-square" class="feather-icon"></i
              ><span class="hide-menu">Chat</span></a
            >
          </li>

          <li class="sidebar-item">
            <a
              class="sidebar-link sidebar-link"
              href="app-calendar.html"
              aria-expanded="false"
              ><i data-feather="calendar" class="feather-icon"></i
              ><span class="hide-menu">Calendar</span></a
            >
          </li>


Menu restante:

<li class="list-divider"></li>

          <li class="nav-small-cap">
            <span class="hide-menu">Components</span>
          </li>

          <li class="sidebar-item">
            <a
              class="sidebar-link has-arrow"
              href="javascript:void(0)"
              aria-expanded="false"
              ><i data-feather="file-text" class="feather-icon"></i
              ><span class="hide-menu">Forms </span></a
            >
          </li>


 */
</script>
